import { useState } from 'react';
import { Link } from 'react-router-dom';
import Logo from '../components/Logo';
import api from '../api';

function ForgotPassword() {
    const [email, setEmail] = useState('');
    const [submitted, setSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);
        try {
            await api.post('/auth/forgot-password', { email: email.trim() });
            setSubmitted(true);
        } catch (err) {
            setError(err.response?.data?.error || 'Something went wrong. Please try again.');
        }
        setLoading(false);
    };

    const inputStyle = {
        width: '100%',
        padding: '14px 16px',
        borderRadius: '12px',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        background: 'rgba(255, 255, 255, 0.05)',
        color: '#ffffff',
        fontSize: '0.95rem',
        boxSizing: 'border-box',
        outline: 'none',
    };

    return (
        <div style={{
            display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
            minHeight: '100vh',
            background: 'linear-gradient(180deg, #12121a 0%, #1a1a2e 50%, #12121a 100%)',
            color: '#ffffff', padding: '20px', position: 'relative', overflow: 'hidden',
        }}>
            <div style={{
                position: 'fixed', top: '-20%', right: '-10%', width: '500px', height: '500px',
                background: 'radial-gradient(circle, rgba(255, 193, 7, 0.12) 0%, transparent 70%)',
                borderRadius: '50%', pointerEvents: 'none', zIndex: 0,
            }} />

            <div style={{ marginBottom: '32px', position: 'relative', zIndex: 10 }}>
                <Link to="/" style={{ textDecoration: 'none' }}>
                    <Logo size="large" dark={false} />
                </Link>
            </div>

            <div style={{
                width: '100%', maxWidth: '420px', padding: '40px',
                background: 'rgba(255, 255, 255, 0.03)',
                border: '1px solid rgba(255, 255, 255, 0.08)',
                borderRadius: '24px', backdropFilter: 'blur(20px)',
                position: 'relative', zIndex: 10, boxSizing: 'border-box',
            }}>
                {submitted ? (
                    <>
                        <div style={{ textAlign: 'center', marginBottom: '16px', fontSize: '2.5rem' }}>📬</div>
                        <h2 style={{ margin: '0 0 12px', textAlign: 'center', fontSize: '1.5rem', fontWeight: 700 }}>
                            Check your email
                        </h2>
                        <p style={{ color: 'rgba(255,255,255,0.6)', textAlign: 'center', margin: '0 0 28px', fontSize: '0.95rem', lineHeight: 1.6 }}>
                            If an account exists for <strong>{email}</strong>, we've sent a password reset link. It expires in 1 hour.
                        </p>
                        <p style={{ textAlign: 'center', margin: 0, fontSize: '0.9rem', color: 'rgba(255,255,255,0.5)' }}>
                            <Link to="/login" style={{ color: '#ffc107', fontWeight: 600, textDecoration: 'none' }}>
                                Back to sign in
                            </Link>
                        </p>
                    </>
                ) : (
                    <>
                        <h2 style={{ margin: '0 0 8px', textAlign: 'center', fontSize: '1.75rem', fontWeight: 700 }}>
                            Forgot Password?
                        </h2>
                        <p style={{ color: 'rgba(255,255,255,0.6)', textAlign: 'center', margin: '0 0 28px', fontSize: '0.95rem' }}>
                            Enter your email and we'll send you a reset link.
                        </p>

                        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                            <div>
                                <label style={{ display: 'block', marginBottom: '8px', fontSize: '0.85rem', color: 'rgba(255,255,255,0.7)' }}>
                                    Email address
                                </label>
                                <input
                                    type="email"
                                    required
                                    autoComplete="email"
                                    placeholder="you@example.com"
                                    value={email}
                                    onChange={e => setEmail(e.target.value)}
                                    style={inputStyle}
                                />
                            </div>

                            {error && (
                                <p style={{ margin: 0, color: '#ef4444', fontSize: '0.88rem', fontWeight: 500 }}>
                                    {error}
                                </p>
                            )}

                            <button
                                type="submit"
                                disabled={loading}
                                style={{
                                    padding: '14px',
                                    background: 'linear-gradient(135deg, #ffc107 0%, #ff9800 100%)',
                                    color: '#000', border: 'none', borderRadius: '12px',
                                    fontWeight: 700, fontSize: '1rem',
                                    cursor: loading ? 'not-allowed' : 'pointer',
                                    opacity: loading ? 0.7 : 1,
                                    boxShadow: '0 4px 20px rgba(255,193,7,0.3)',
                                }}
                            >
                                {loading ? 'Sending…' : 'Send Reset Link'}
                            </button>
                        </form>

                        <p style={{ textAlign: 'center', marginTop: '24px', marginBottom: 0, fontSize: '0.9rem', color: 'rgba(255,255,255,0.6)' }}>
                            <Link to="/login" style={{ color: '#ffc107', fontWeight: 600, textDecoration: 'none' }}>
                                Back to sign in
                            </Link>
                        </p>
                    </>
                )}
            </div>
        </div>
    );
}

export default ForgotPassword;
